import { DataTable } from "mantine-datatable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover, Select, Text, TextInput } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from '@mantine/core';
import { IconSearch } from "@tabler/icons-react";
import { AiOutlineDelete } from "react-icons/ai";
import { destroyDepartment } from "../../../redux/actions/departmentAction";
import { destroyLocation, fetchRegionLocation } from "../../../redux/actions/locationAction";
import LocationsModal from "../../modal/locations/LocationsModal";
import { fetchRegion } from "../../../redux/actions/regionAction";


const LocationsListTable = ({ PAGE_SIZE = 30 }) => {
    const [data, setLocationData] = useState([]);
    const [dataOfTable, setDataOfTable] = useState(data || []);
    const [page, setPage] = useState(1);
    const { loading, locationsByRegion } = useSelector((state) => state?.location);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [regionData, setRegionsData] = useState([])

    const [records, setRecords] = useState(dataOfTable?.slice(0, PAGE_SIZE) || []);


    const [query, setQuery] = useState('');
    const { regionList } = useSelector((state) => state?.region)

    useEffect(() => {
        dispatch(fetchRegion())
    }, [])

    useEffect(() => {
        const names = regionList.map((item) => ({ value: item.id, label: item.name }));
        setRegionsData(names);
    }, [regionList])

    useEffect(() => {
        setDataOfTable(
            data?.filter(({ name }) => {
                return name?.toLowerCase()?.includes(query?.trim()?.toLowerCase());
            })
        );
    }, [query]);




    useEffect(() => {
        setDataOfTable(data);
    }, [data]);



    useEffect(() => {
        dispatch(fetchRegionLocation(regionData[0]?.value || 2));
    }, [regionData]);

    useEffect(() => {
        setLocationData(locationsByRegion)
    }, [locationsByRegion]);

    useEffect(() => {
        const from = (page - 1) * PAGE_SIZE;
        const to = from + PAGE_SIZE;
        setRecords(dataOfTable?.slice(from, to));
    }, [page, dataOfTable]);

    const handleDelete = async (id) => {
        await dispatch(destroyLocation(id)).then((res) => {
            if (dataOfTable?.length !== 1 && records.length === 1) {
                setPage(page - 1);
            }
        });
    };



    const product_columns = [
        {
            accessor: "SNO",
            title: <Text>#</Text>,
            width: "auto",
            render: (record, i) => <Text>{i + 1}</Text>,
        },
        {
            accessor: "id",
            width: "auto",
            title: "Id",
        },
        {
            accessor: "name",
            width: "auto",
            title: "Location",
            filter: (
                <TextInput
                    label="Location"
                    placeholder="Search Locations..."
                    icon={<IconSearch size={16} />}
                    value={query}
                    onChange={(e) => setQuery(e.currentTarget.value)}
                />
            ),
        },

        {
            accessor: "actions",
            width: "auto",
            textAlignment: "right",
            title: <Text>Actions</Text>,
            render: (record) => (
                <div>
                    <Popover width={300} trapFocus position="bottom" withArrow shadow="md">
                        <Popover.Target>
                            <Button
                                className='fa-2x px-1'
                                size='sm'
                                variant="gradient"
                                gradient={{ from: 'rgba(235, 0, 0, 1)', to: 'rgba(255, 0, 106, 1)', deg: 59 }}>
                                <AiOutlineDelete />
                            </Button>
                        </Popover.Target>
                        <Popover.Dropdown>
                            <div className='d-flex align-items-start flex-column'>
                                <p className='text-left'>Are you sure, want to delete</p>
                                <Button
                                    onClick={() => handleDelete(record.id)}
                                    variant="filled" color="red">
                                    Delete
                                </Button>
                            </div>
                        </Popover.Dropdown>
                    </Popover>
                </div>
            ),
        },
    ];

    const [OpenModal, setOpenModal] = useState(false)

    return (
        <div>
            <LocationsModal setModalPopup={setOpenModal} modalPopup={OpenModal} setLocationData={setLocationData} />
            <div className="d-flex mb-3 justify-content-between align-items-end">
                <h3 className="m-0 col-md-4"  >Locations List</h3>
                <div className="col-12 col-md-8 row d-flex gap-2 justify-content-end align-items-end">
                    <Select
                        onChange={(e) => dispatch(fetchRegionLocation(e))}
                        label="Regions"
                        name='regions'
                        defaultValue={regionData.length > 0 && regionData[0]?.value || 2}
                        placeholder="Please Select"
                        data={regionData}
                        className='mt-3  col-md-3 required-input'
                    />
                    <Button
                        className="text-uppercase col-md-4  "
                        variant="gradient"
                        gradient={{ from: 'lime', to: 'teal', deg: 90 }}
                        onClick={() => setOpenModal(true)}>
                        Add New Location
                    </Button>
                    <Button
                        className="text-uppercase col-md-4   "
                        variant="gradient"
                        gradient={{ from: 'red', to: 'yellow', deg: 125 }}
                        onClick={() => navigate('/location/bulk')}>
                        Add Bulk Locations
                    </Button>
                </div>
            </div>
            <DataTable
                className="data-table-with-actions"
                withBorder
                records={records}
                withColumnBorders
                striped
                highlightOnHover
                verticalSpacing={10}
                columns={
                    product_columns
                }
                totalRecords={dataOfTable?.length}
                recordsPerPage={PAGE_SIZE}
                page={page}
                onPageChange={(p) => setPage(p)}
                fetching={loading}
                minHeight={400}
                loaderVariant="dots"
                noRecordsText="No records found"
                paginationText={({ from, to, totalRecords }) =>
                    `Records ${from} - ${to} of ${totalRecords}`
                }
                paginationSize="md"
            />
        </div>
    );
}

export default LocationsListTable